import { Template } from "../ImageGeneration/types";

// Explizites Mapping von suggestedPostTypes-Werten (z. B. vom LLM als
// snake_case geliefert) auf die exakten Template-Namen aus templates.ts.
// Hier alle bekannten Post-Types eintragen, damit das Matching zuverlässig ist.
export const postTypeToTemplateName: Record<string, string> = {
    speaker_announcement: "Speaker Announcement",
    event_announcement: "GameDays Announcement",
    event_attendance_announcement: "AG Portrait Format Light",
    event_review: "AG Landscape Format Light",
    short_post:"AG Landscape Format Light",
    // weitere Zuordnungen hier ergänzen, z.B.:
    // event_recap: "Event Recap",
    // quote_card: "Quote Card",
};

// Fallback, falls ein Post-Type nicht in der Tabelle steht:
// "speaker_announcement" -> "Speaker Announcement"
const snakeCaseToTitleCase = (value: string): string =>
    value
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

/**
 * Löst einen suggestedPostTypes-Wert zum passenden Template auf.
 * Reihenfolge: 1) explizites Mapping, 2) direkter Namens-Match,
 * 3) snake_case -> Title Case Fallback. Gibt undefined zurück,
 * wenn nichts passt.
 */
export const resolveTemplate = (
    postType: string,
    templates: Template[]
): Template | undefined => {
    const mappedName = postTypeToTemplateName[postType];
    if (mappedName) {
        const match = templates.find((t) => t.name === mappedName);
        if (match) return match;
    }

    // Direkter Match, falls suggestedPostTypes bereits den Template-Namen liefert
    const directMatch = templates.find((t) => t.name === postType);
    if (directMatch) return directMatch;

    // Fallback: snake_case in Title Case umwandeln und erneut versuchen
    const fallbackName = snakeCaseToTitleCase(postType);
    return templates.find((t) => t.name === fallbackName);
};